export enum DonationType {
    one_shot = "one_shot",
    monthly = "monthly"
}